import { compose } from "redux";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core";

import WorkScheduleReportItem from "features/planner/report/workSchedule/components/WorkScheduleReportItem";
import WorkScheduleReportBase from "features/planner/report/workSchedule/components/WorkScheduleReportBase";
import WorkScheduleMonthReportWorkDay from "features/planner/report/workSchedule/components/month/WorkScheduleMonthReportWorkDay";

class WorkScheduleMonthReport extends PureComponent {
  renderDate = (employeeCard, date, index) => {
    const { classes } = this.props;

    const workDay = employeeCard
      .get("scheduleDays")
      .find(x => date.isSame(x.get("date"), "day"));

    return workDay ? (
      <WorkScheduleMonthReportWorkDay key={index} workDay={workDay} />
    ) : (
      <WorkScheduleReportItem
        key={index}
        classes={{
          root: classes.workScheduleReportItem,
        }}
      />
    );
  };

  render() {
    const { report, dates } = this.props;

    return (
      <WorkScheduleReportBase
        dates={dates}
        report={report}
        renderDate={this.renderDate}
      />
    );
  }
}

const styles = theme => ({
  workScheduleReportItem: {
    borderLeft: theme.altus.workScheduleReport.defaultBorder,
    "& + $workScheduleReportItem": {
      borderLeft: theme.altus.workScheduleReport.placeholderBorder,
    },
  },
});

export default compose(withStyles(styles))(WorkScheduleMonthReport);
